<!-- 登录dialog -->
<template>
  <el-dialog
    :title="registerFlag ? '注册' : '登录'"
    :visible.sync="isLoginDialog"
    :close-on-click-modal="false"
    :show-close="false"
    :center="true"
    class="login"
  >
    <div v-if="!registerFlag">
      <el-form
        :model="loginForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        hide-required-asterisk
      >
        <el-form-item label="账号:" prop="user_name">
          <el-input
            placeholder="请输入手机号"
            v-model="loginForm.user_name"
            clearable
            class="user_input"
            ref="user_input"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="密码:" prop="password">
          <el-input
            placeholder="请输入密码"
            v-model="loginForm.password"
            show-password
            class="password_input"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="checked"> </el-checkbox>
          已阅读并同意
          <router-link target="_blank" to="ysbh">《隐私保护指引》</router-link
          >和<router-link target="_blank" to="yhxy"
            >《用户协议生成》</router-link
          >
        </el-form-item>
        <div class="register" @click="goRegister()">注册</div>
      </el-form>

      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="offIsLoginDialog">取 消</el-button>
        <el-button type="primary" @click="login" :loading="loginLoading">{{
          loginLoading ? "登录中" : "登 录"
        }}</el-button>
      </div>
    </div>

    <!-- 注册  -->
    <div v-else>
      <el-form
        :model="registerForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        hide-required-asterisk
      >
        <el-form-item label="账号:" prop="user_name">
          <el-input
            placeholder="请输入手机号"
            v-model="registerForm.user_name"
            clearable
            class="user_input"
            ref="user_input"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="密码:" prop="password">
          <el-input
            placeholder="请输入密码"
            v-model="registerForm.password"
            show-password
            class="password_input"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码:" prop="password">
          <el-input
            placeholder="请确保第二次密码与上面的一致"
            v-model="password2"
            show-password
            class="password_input"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="checked"> </el-checkbox>
          已阅读并同意
          <router-link target="_blank" to="ysbh">《隐私保护指引》</router-link
          >和<router-link target="_blank" to="yhxy"
            >《用户协议生成》</router-link
          >
        </el-form-item>
        <div class="register" @click="registerFlag = false">去登陆</div>
      </el-form>

      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="offIsLoginDialog">取 消</el-button>
        <el-button type="primary" @click="register()" :loading="loginLoading">{{
          loginLoading ? "注册中" : "注 册"
        }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script >
export default {
  name: "loginDialog",
  data() {
    return {
      registerFlag: false,
      checked: false,
      password2: "",
      registerForm: {
        user_name: "",
        password: "",
      },
      loginForm: {
        user_name: "",
        password: "",
      },
      loginLoading: false,
      rules: {
        user_name: [
          { required: true, message: "账号不能为空", trigger: "blur" },
          {
            min: 11,
            max: 11,
            message: "账号为长度为11位的手机号",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          { min: 6, message: "密码长度需要大于6位", trigger: "blur" },
        ],
      },
    };
  },
  props: {
    isLoginDialog: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  created() {},
  computed: {
    loginDialog() {
      return this.$store.getters.loginDialog;
    },
  },
  mounted() {},
  methods: {
    goRegister() {
      this.registerFlag = true;
    },
    offIsLoginDialog() {
      this.$emit("update:isLoginDialog", false);
    },
    register() {
      if (!this.checked) {
        return this.$message({
          message: "请确认已阅读《隐私保护指引》和《用户协议生成》",
          type: "warning",
        });
      }
      this.loginLoading = true; //显示登录加载的提示
      this.$axios
        .post(`/register`, this.registerForm)
        .then((res) => {
          let resData = res.data;
          if (0 == resData.status) {
            this.registerFlag = false;
            this.$message({
              message: "注册成功，请登录",
              type: "success",
            });
            this.registerForm = {
              user_name: "",
              password: "",
            };
          } else {
            this.$message.error(resData.message);
          }
        })
        .finally(() => {
          this.loginLoading = false; //恢复登录按钮的点击状态
        });
    },
    login() {
      if (!this.checked) {
        return this.$message({
          message: "请确认已阅读《隐私保护指引》和《用户协议生成》",
          type: "warning",
        });
      }
      this.loginLoading = true; //显示登录加载的提示
      this.$axios
        .post(`/login`, this.loginForm)
        .then((res) => {
          let resData = res.data;
          if (0 == resData.status) {
            localStorage.setItem("userData", JSON.stringify(resData.data));
            this.$emit("update:isLoginDialog", false);
            this.$emit("resData", resData.data);
            console.log(resData.data);
            this.$axios
              .get(`/getGoodsCar?user_id=${resData.data.user_id}`)
              .then((res) => {
                let resData = res.data.data;
                console.log(resData);
                this.$store.commit("setCarPanelData", resData);
              });
          } else {
            this.$message.error(resData.message);
          }
          this.goodsData = res.data.data;
        })
        .finally(() => {
          this.loginLoading = false; //恢复登录按钮的点击状态
        });
    },
  },
};
</script>
<style scoped>
.register {
  padding: 10px 0px 5px 8%;
  cursor: pointer;
}
.register:hover {
  color: brown;
}
.password_input,
.user_input {
  width: 80%;
}
.login >>> .el-dialog {
  max-width: 700px;
  min-width: 550px;
}
</style>


// WEBPACK FOOTER //
// src/components/login/index.vue